import { useContext, useEffect, useMemo, useState } from 'react'
import { useParams, Navigate } from "react-router-dom"
import { enqueueSnackbar } from 'notistack'

import { AppContext } from '/providers/app-context'
import { getScanReportScans } from '/providers/templates-api'

import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/template-stats'
import Menu from '/components/templates/template-nav-menu'
import ReportTable from '../components/templates/scan-report-scans-table'
import moment from 'moment-timezone'

const TemplateScanReports = () => {

  const { templateId, ts } = useParams()
  const { apiSource,apiKey,loadingTemplates, templates } = useContext(AppContext)

  const [scans,setScans] = useState([])
  const [loading, setLoading] = useState(true)

  const template = useMemo(() => {return templates.filter(t => t.template_id === templateId)[0]}, [templates, templateId])

  const dateString = moment(ts,"YYYYMMDD").format("DD MMM YYYY")

  useEffect(() => {
    if (template) getScanReportDateData()
  }, [template, templateId, ts])

  if (!loadingTemplates && !template) return <Navigate to="/templates" replace />
  
  const heading = useMemo(() => template ? `${template.name} ${template.archived ? " [archived]" : ""} (${dateString})` : "",[template])

  const getScanReportDateData = async () => {
    const d = await getScanReportScans({apiSource,apiKey,templateId,ts})
    
    if (d.error) {
      enqueueSnackbar({ message: d.error, variant: 'error' })
    } else {
      setScans(d.scans)
      setLoading(false)
    }
    setLoading(false)
  }

  return (
    <PageWrapper title={`Daily Scan Reports ${dateString}`} HelpText={HelpText} heading={heading} menu={<Menu template={template} />}>
      <ReportTable templateId={templateId} pass_type_id={template?.pass_type_id} scans={scans} loading={loading}/>
    </PageWrapper>
  )
}

export default TemplateScanReports
